import { format } from 'date-fns';
import numeral from 'numeral';

export const formatDateString = (date: string) => {
  return format(new Date(date), 'MMM dd, yyyy');
};

export const formatCurrency = (value: number) => {
  return numeral(value).format('$0,0.00');
};

export const getPlural = (number: number, string: string) => (number === 1 ? string : `${string}s`);

export const formatISOTimeStringWithoutTZ = (data: string | Date) => {
  return format(typeof data === 'string' ? new Date(data) : data, "yyyy-MM-dd'T'HH:mm:ss.SSS");
};
